import { apiClient } from "@/shared/api/client"
import type { Duration, Format, Niche, Topic } from "@/shared/lib/types"

/** Fetches all available post formats. */
export const getFormats = async (): Promise<Format[]> => {
	const response = await apiClient.get<Format[]>("/formats")
	return response.data
}

/** Fetches all available post niches. */
export const getNiches = async (): Promise<Niche[]> => {
	const response = await apiClient.get<Niche[]>("/niches")
	return response.data
}

/** Fetches all available post topics. */
export const getTopics = async (): Promise<Topic[]> => {
	const response = await apiClient.get<Topic[]>("/topics")
	return response.data
}

/** Fetches all available post durations. */
export const getDurations = async (): Promise<Duration[]> => {
	const response = await apiClient.get<Duration[]>("/durations")
	return response.data
}
